import { LocalStorage } from 'quasar';

export function setCountry({ commit }, value) {
  commit('setCountry', value);
}
